import { DucatClientAPI } from '@/context/DucatClientCtx';
import { v4 as uuidv4 } from 'uuid';

export async function sha256Hex(value: string): Promise<string> {
  const encoder = new TextEncoder();
  const data = encoder.encode(value);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
}

interface QuantaHeaderParams {
  userPublicKey: string;
  address: string;
  hash: string;
  value: string;
  signedMessage: string;
}

export type QuantaHeaders = {
  'x-hash': string;
  'x-value': string;
  'x-user-public-key': string;
  'x-address': string;
  'x-signed-message': string;
  'ngrok-skip-browser-warning'?: boolean;
};

export function buildQuantaHeaders(params: QuantaHeaderParams): QuantaHeaders {
  return {
    'x-hash': params.hash,
    'x-value': params.value,
    'x-user-public-key': params.userPublicKey,
    'x-address': params.address,
    'x-signed-message': params.signedMessage,
    'ngrok-skip-browser-warning': true,
  };
}

export async function signQuantaAuth({
  address,
  pubkey, // remove
  client,
}: {
  address: string;
  pubkey: string;
  client: DucatClientAPI;
}): Promise<QuantaHeaderParams> {
  const value = uuidv4();
  // const hash = bitcore.crypto.Hash.sha256(Buffer.from(value)).toString('hex');
  const hash = await sha256Hex(value);
  const signedMessageResponse = await client.signMessage({ address, message: hash });
  if (!signedMessageResponse?.result?.signature) {
    throw Error('Failed to sign message');
  }
  const signedMessage = signedMessageResponse?.result?.signature;

  return {
    address,
    hash,
    value,
    signedMessage,
    userPublicKey: pubkey,
  };
}
